import React, { useEffect, useState } from "react";
import "./HP_SectionOne.scss";
import { getHeadersProducts } from "../../../services/headersProducts/headersProducts";
import { useParams } from "react-router-dom";
import { GoChevronDown } from "react-icons/go";
import FilterProducts from "../../../components/FilterProducts";
import Products from "../../../components/Products";

export const paramsFilterDefault = {
  q: "",
  page: 1,
  name: "",
  size: "",
  color: "",
  condition: "",
  priceSort: "",
};

function HP_SectionOne() {
  const [headersProducts, setHeadersProducts] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [rotateIcon, setRotateIcon] = useState(null);
  const [productsFiltered, setProductsFiltered] = useState([]);
  const [paramsFilterUser, setParamsFilterUser] = useState(paramsFilterDefault);

  const params = useParams();

  useEffect(() => {
    const fetchApi = async () => {
      const contentHeadersProducts = await getHeadersProducts(
        params.name,
        params.key
      );
      setHeadersProducts(contentHeadersProducts);

      setParamsFilterUser({ ...paramsFilterDefault });

      if (contentHeadersProducts.length > 0) {
        const defaultProducts = [...contentHeadersProducts[0].products].sort(
          (a, b) => b.idProducts - a.idProducts
        );
        setProductsFiltered(defaultProducts);
      } else {
        setProductsFiltered([]);
      }
    };
    fetchApi();
  }, [params.name, params.key]);

  useEffect(() => {
    if (headersProducts.length === 0) return;

    const allProducts = headersProducts[0].products;
    let rs = [...allProducts];

    if (paramsFilterUser.name)
      rs = rs.filter((p) => p.name === paramsFilterUser.name);

    if (paramsFilterUser.size)
      rs = rs.filter((p) => p.size === paramsFilterUser.size);

    if (paramsFilterUser.color)
      rs = rs.filter((p) => p.color === paramsFilterUser.color);

    if (paramsFilterUser.condition)
      rs = rs.filter((p) => p.condition === paramsFilterUser.condition);

    if (paramsFilterUser.priceSort === "cao-den-thap") {
      rs.sort(
        (a, b) =>
          b.price_old * (1 - b.sales / 100) - a.price_old * (1 - a.sales / 100)
      );
    }

    if (paramsFilterUser.priceSort === "thap-den-cao") {
      rs.sort(
        (a, b) =>
          a.price_old * (1 - a.sales / 100) - b.price_old * (1 - b.sales / 100)
      );
    }

    if (!paramsFilterUser.priceSort) {
      rs.sort((a, b) => b.idProducts - a.idProducts);
    }

    setProductsFiltered(rs);
  }, [paramsFilterUser, headersProducts]);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setRotateIcon(rotateIcon === index ? null : index);
  };

  return (
    <div className="hp-sectionOne">
      <div className="container">
        {headersProducts.map((item, index) => (
          <div className="hp-sectionOne-wrapper" key={item.id}>
            <div
              className="hp-sectionOne-title"
              onClick={() => handleToggle(index)}
            >
              <span className="title">
                {item.title}
                <GoChevronDown
                  className={`icon ${rotateIcon === index ? "active" : ""}`}
                />
              </span>
              <div className="results">({item.results})</div>
              <div className={`sub ${activeIndex === index ? "active" : ""}`}>
                {item.sub_details}
              </div>
            </div>

            <FilterProducts
              headersProducts={headersProducts}
              paramsFilterUser={paramsFilterUser}
              setParamsFilterUser={setParamsFilterUser}
            />

            <Products productsFiltered={productsFiltered} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default HP_SectionOne;
